export const TERMS_OF_SERVICE_URL = ' https://buttercup-coral-e9a.notion.site/9e7c367b66524429b1dee93c05d2929b?pvs=4';

export const PRIVACY_POLICY_URL = 'https://buttercup-coral-e9a.notion.site/5db1eda2ab184b6c9f860103119b2d17?pvs=4';

export const ABOUT_US_URL = 'https://buttercup-coral-e9a.notion.site/About-Us-80904015830149b2995ecedc7ad75311?pvs=4';

export const APPLY_SERVICE_URL = 'https://tally.so/r/w5EgKZ';

export const APPLY_MANAGER_URL = 'https://tally.so/r/mV4pR6';

export const ABOUT_CHECKMATE_URL =
  'https://buttercup-coral-e9a.notion.site/About-CheckmateKorea-1e4c00e5608680048c69fe0ac3b7da11?pvs=4';

export const WHY_CHECKMATE_URL =
  'https://buttercup-coral-e9a.notion.site/Why-CheckmateKorea-1e4c00e56086806599eefb938f144389?pvs=4';

export const MEMBERSHIP_URL =
  'https://buttercup-coral-e9a.notion.site/Checkmate-Membership-1d8c00e5608680c4b530ea0b86e3fff8';

export const EVENTS_URL = 'https://buttercup-coral-e9a.notion.site/Events-Benefits-1d3c00e5608680b4868ef5d3f5155bdf';

export const HELP_CENTER_URL =
  'https://buttercup-coral-e9a.notion.site/Help-Center-a65dec1c44ca44958a2d192d5119017e?pvs=4';

export const ONLINE_SALES_URL = 'http://www.ftc.go.kr/bizCommPop.do?wrkr_no=5868703123';

export const CHECKMATE_PLUS_URL =
  'https://buttercup-coral-e9a.notion.site/Checkmate-Plus-1d3c00e5608680b4868ef5d3f5155bdf';

export const CHECKMATE_MEMBERSHIP_URL =
  'https://buttercup-coral-e9a.notion.site/Checkmate-Membership-1d8c00e5608680c4b530ea0b86e3fff8';

export const CHECK_WITH_YOU_URL = 'https://tally.so/r/w5EgKZ';

export const CONTRACT_ACCOMPANIMENT_URL = 'https://tally.so/r/mV4pR6';
